import { apiListPC } from '@/api'
import ajax from '@/api/ajax'
import { downloadFile } from '@/utils/downloadFile/downloadFile'
import qs from 'qs'
export async function downLoadPDF(surveyId, enterpriseId, surveyName) {
    if (this.$lock) {
        this.$message.warning('您的服务已到期，部分功能已受限，如有问题，请联系工作人员', 2)
        return
    }

    this.bus.$emit('loading', true)
    await ajax(
        apiListPC.downloadPdf,
        {
            url: `${window.location.href.split('#')[0]}#/Report?${qs.stringify({
                authentication: localStorage.getItem('token'),
                surveyId,
                surveyName,
                enterpriseId,
                download: true,
                license: window.config.license,
            })}`,
            filename: '企业风险自检报告.pdf',
        },
        'POST',
        '',
        { responseType: 'blob' }
    )
        .then((res) => {
            downloadFile(res, `${surveyName || '企业'}风险报告.pdf`)
            this.bus.$emit('loading', false)
            if (this.$route.query.download == 'true') {
                this.$router.back(-1)
            }
        })
        .catch((err) => {
            this.bus.$emit('loading', false)
            this.$message.error('下载失败，请重试')
        })
}
